<template>
    <div class="couponCodeForm">
        <form @submit.stop.prevent="submit">
            <div
                v-show="isOption"
                class="small text-muted mb-2">
                クーポンコードをお持ちの方は、ここから割引クーポンを発行してください。
            </div>
            <div class="input-group">
                <input
                    v-model="code"
                    type="text"
                    id="couponCodeInput"
                    class="form-control"
                    :class="{ 'is-invalid' : errors.code }"
                    placeholder="クーポンコードを入力">
                <div
                    v-if="errors.code"
                    class="invalid-feedback d-block">
                    {{ errors.code[0] }}
                </div>
            </div>

            <div class="d-flex justify-content-center mt-4">
                <b-button
                    type="submit"
                    variant="yokumiru-orange"
                    :disabled="inProgress">
                    クーポンを発行
                </b-button>
            </div>
        </form>
    </div>
</template>

<script>
import constants from '../../constants'

export default {
    props: {
        couponCode: {
            type: Object,
            default: null,
        },
        isOption: {
            type: Boolean,
            default: false,
        },
        planKey: {
            type: String,
            default: null,
        },
    },

    data: function () {
        return {
            inProgress: false,
            code: null,
            errors: {},
        }
    },

    created: function () {
        if (this.couponCode) {
            this.code = this.couponCode.code
        }
    },

    methods: {
        /**
         * クーポン発行
         */
        submit: async function (e) {
            e.preventDefault()

            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.user.user_coupons.endpoint.base

            let params = { code: this.code }
            if (this.planKey) {
                params.plan_key = this.planKey
            }

            await axios.post(`${endpoint}/publish`, params)
                .then(() => {
                    bus.$emit('alert-success', 'クーポンを発行しました。')
                    bus.$emit('user-coupon-published', 'クーポンを発行しました。')
                    this.code = null
                    this.errors = {}
                })
                .catch(({response}) => {
                    if (response &&
                        response.hasOwnProperty('data') &&
                        response.data.hasOwnProperty('errors')) {
                        if (response.data.errors.hasOwnProperty('message')) {
                            bus.$emit('alert-danger', response.data.errors.message[0])
                        }
                        this.errors = response.data.errors
                        bus.$emit('alert-danger')
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                })

            this.inProgress = false
        },
    },
}
</script>

<style lang="scss" scoped>
.couponCodeForm {
    padding: 20px 20px 10px;
}
</style>
